import JSONbig from 'json-bigint'
import { API_BASE } from './config.js'

const jsonParser = JSONbig({ storeAsString: true })

function getToken() {
  return localStorage.getItem('token') || ''
}

function request(method, path) {
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + getToken()
  }
  return fetch(`${API_BASE}${path}`, { method, headers, credentials: 'include' })
    .then(res => res.text())
    .then(text => jsonParser.parse(text))
}

/**
 * 查询成就徽章墙。
 *
 * 后端会顺带做一次评估（把已达成的成就落库），返回：
 *   data.overview       —— 概览（已获得 / 总数 / 完成度 / 最近获得 / 连续记录）
 *   data.list           —— 全部成就（含未解锁）
 *   data.newlyUnlocked  —— 本次新解锁的成就（用于弹解锁提醒）
 *
 * @returns {Promise<{code:number,message:string,data:Object,success:boolean,timestamp:string}>}
 */
export function getAchievementWall() {
  return request('GET', '/api/v1/achievements')
}

/**
 * 轻量检测新解锁成就（只返回本次新解锁的列表，不返回整面墙）。
 * 用于创建时间块 / 加好友 / 点赞 / 评论之后即时弹提醒。
 *
 * @returns {Promise<{code:number,message:string,data:Array,success:boolean,timestamp:string}>}
 */
export function checkAchievements() {
  return request('GET', '/api/v1/achievements/check')
}
